<template>
    <Layout>
        <div class="view-plugin-form suggest-form">
            <section class="fieldset">
                <form class="form">
                    <div class="form-row">
                        <label class="form-label">Catégorie</label>
                        <select class="form-input" name="category" v-model="category">
                            <option :value="null">Choisissez une catégorie</option>
                            <option v-for="category in categories"
                                    :value="category.id">{{ category.name }}</option>
                            <option :value="0">Autre</option>
                        </select>
                    </div>
                    <div class="form-row">
                        <label class="form-label">Nom du service à interfacer</label>
                        <input type="text" maxlength="100" name="service" class="form-input" v-model="service"/>
                    </div>
                    <div class="form-row">
                        <label class="form-label">Description du plugin souhaité</label>
                        <textarea name="description" maxlength="5000" class="form-input" v-model="description"></textarea>
                    </div>
                </form>
            </section>
        </div>
        <div slot="toolbar">
            <Btn @click.native="send" class="primary mobile-block pull-right">Envoyer</Btn>
        </div>
    </Layout>
</template>

<script>
    //import Component from 'path/to/component'

    import _filter from 'lodash/filter'

    import {mapGetters, mapMutations, mapActions} from 'vuex'

    import globalMixin from '@/mixins/global'

    import Layout from '@l/BaseWithToolbar'

    import FormBuilder from '@c/plugins/formbuilder/FormBuilder'
    import PluginItem from '@c/plugins/library/PluginItem'

    import transformers from '@s/transformers'

    import _find from 'lodash/find'

    import descriptor01 from '@a/json/descriptor01.json'
    import configuration01 from '@a/json/configuration01.json'

    export default {
        beforeCreate: function () {


        },
        beforeDestroy: function () {

        },
        beforeMount: function () {


        },
        beforeUpdate: function () {

        },
        components: {
            Layout,
        },
        computed: {
            ...mapGetters({
                categories: 'Plugins/categories'
            }),


        },
        created: function () {

        },
        data() {
            return {
                category: null,
                service: '',
                description: ''
            }
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
            }),

            ...mapActions({
                fetchCategories: 'Plugins/fetchCategories',
                suggest: 'Plugins/suggest'
            }),

            send(){

                if(this.category === null){
                    this.addError('La catégorie est obligatoire')
                }
                else if(this.service === ''){
                    this.addError('Le nom du service est obligatoire')
                }
                else if(this.description === ''){
                    this.addError('La description est obligatoire')
                }
                else {

                    this.showLoading(true)
                    this.suggest({
                        category: this.category,
                        service: this.service,
                        description: this.description
                    }).then(response => {
                        this.addSuccess('Votre suggestion a bien été envoyée.')
                        this.$router.replace({name: 'pluginsLibrary'})
                    }).catch(error => {
                        this.showLoading(false)
                        this.addError(error)
                    })

                }
            }

        },
        mixins: [
            globalMixin
        ],
        mounted: function () {
            this.$store.commit('UI/viewTitle', this.$i18n.t('plugins.titles.suggest'))
            this.$store.commit('UI/backAction', 'historyBack')
            this.fetchCategories().then(response => {
                this.showLoading(false)
            })



        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .suggest-form {
        padding: 20px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .fieldset {
            height: auto;
            width: 50%;
            display: flex;
            flex-direction: column;
            margin: 0 auto;

            label{
                padding-right: 10px;
                flex: 0 0 200px;
            }

            textarea{
                height: 200px;
                margin-bottom: 0;
            }

            .form-row:last-child{
                margin-bottom: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/plugins/Suggest.vue